<template>
  <el-card>
    <div slot="header"></div>
    <div class="flex flex-sb flex-cc title">
      <span>商品分类</span>
      <el-button type="primary" @click="onAdd">新增分类</el-button>
    </div>
    <el-table :data="tableList">
      <el-table-column prop="title" label="分类名称"></el-table-column>
      <el-table-column label="分类排序">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.sort" controls-position="right" :min="0" :max="99999" @change="handleChangeInput($event, row)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="{ row }">
          <el-switch :value="!!row.onShow" @change="handleChangeSwitch($event, row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110px">
        <template slot-scope="{ row }">
          <el-button @click="onEdit(row)" type="text">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" title="你确定要删除该数据么？" @confirm="handleDelete(row)">
            <el-button slot="reference" type="text" class="danger" :disabled="row.giftCount > 0">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="meta" :total="meta.total" :pagination="meta.pagination" :changed="loadCategory" />
    <el-dialog :close-on-click-modal="false" :title="formType | filterTitle" :visible="visible" width="520px">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="分类名称" prop="title">
          <el-input v-model.trim="form.title" placeholder="请输入分类名称，不超过10字" :maxlength="10" />
        </el-form-item>
        <el-form-item label="分类排序" prop="sort">
          <el-input v-model.trim="form.sort" placeholder="请输入分类排序值（排序值越大排名越靠前）" :min="0" :max="99999" @input="onChangeFormSort" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { categoryApi, categoryUpdateApi, categoryRemoveApi, categoryCreateApi } from '@/api/category'

export default {
  data() {
    return {
      tableList: [],
      meta: null,
      visible: false,
      formType: 'add',
      form: {
        title: '',
        sort: ''
      },
      rules: {
        title: [{ required: true, message: '请输入分类名称', trigger: ['change', 'blur'] }],
        sort: [{ required: true, message: '请输入分类排序值', trigger: ['change', 'blur'] }]
      }
    }
  },
  filters: {
    filterTitle(type) {
      switch (type) {
        case 'add':
          return '新增礼品分类'
        case 'edit':
          return '修改礼品分类'
      }
    }
  },
  methods: {
    async loadCategory(params = {}) {
      const { collection, meta } = await categoryApi(params)
      this.tableList = collection
      this.meta = meta
    },
    onAdd() {
      this.form = { title: '', sort: '' }
      this.visible = true
    },
    onEdit(row) {
      this.form = row
      this.visible = true
    },
    onChangeFormSort(e) {
      const sort = parseInt(e)
      this.form.sort = isNaN(sort) ? '' : sort
    },
    async handleChangeInput(sort, { id }) {
      await categoryUpdateApi({ sort, id })
      this.$message.success('排序修改成功')
      this.loadCategory()
    },
    async handleChangeSwitch(onShow, { id }) {
      await categoryUpdateApi({ onShow, id })
      this.$message.success('是否显示修改成功')
      this.loadCategory()
    },
    async handleDelete({ id }) {
      await categoryRemoveApi(id)
      this.$message.success('删除成功')
      this.loadCategory()
    },
    handleSubmit() {
      const { ruleForm } = this.$refs
      ruleForm.validate(async valid => {
        const { form } = this
        if (valid) {
          if (form.id) {
            await categoryUpdateApi(form)
            this.$message.success('修改成功')
          } else {
            await categoryCreateApi(form)
            this.$message.success('新增成功')
          }
          ruleForm.clearValidate()
          this.visible = false
          this.loadCategory()
        } else {
          return false
        }
      })
    }
  },
  created() {
    this.loadCategory()
  }
}
</script>

<style scoped lang="less">
.danger {
  color: #e54d42;

  &[disabled] {
    color: rgba(0, 0, 0, 0.25);
  }
}
</style>
